import { isAxiosError } from "./util";

export const getAxiosErrorStatusAndMessage = (
  error: unknown
): { status?: number; message?: string } => {
  if (!isAxiosError(error)) {
    return {};
  }
  const data = error.response?.data as { message?: unknown } | undefined;
  return {
    status: error.response?.status,
    message: typeof data?.message === "string" ? data.message : undefined,
  };
};

/** 409 duplicate-row conflicts (not product/entity edit locks). */
export const isDuplicateCollectionRowConflict = (error: unknown): boolean => {
  const { status, message } = getAxiosErrorStatusAndMessage(error);
  if (status !== 409) {
    return false;
  }
  return !message?.toLowerCase().includes("being edited by another user");
};
